import styled from 'styled-components'

export const PickupHeaderWrapper = styled.div`
  .title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 40px;
  }
  .button-link {
    text-decoration: none;
  }

  .filter-wrapper {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 25px 40px;
    background: ${props => props.theme.colors.alabaster};
  }

  .title {
    color: ${props => props.theme.colors.primary};
    margin: 0;
    font-size: ${props => props.theme.fontSizes.section.sectionTitle};
  }

  .filter-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    z-index: 2;

    .form-select {
      /*height: 50px;*/

      .select-field {
        /*height: 50px !important;*/
        border: none !important;
        border-radius: 4px;
      }
    }
  }

  .filter-button > div {
    height: 50px;
    line-height: 50px;
  }

  .filter-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    & > div {
      margin-right: 35px;
      height: 100%;
    }
  }

  .clear-button {
    align-self: flex-end;

    & > div {
      background: ${props => props.theme.colors.primary};
      position: relative;
      padding-left: 40px;

      svg {
        position: absolute;
        height: 100%;
        width: 14px;
        fill: ${props => props.theme.colors.white};
        font-size: 18px;
        font-weight: 100;
        left: 20px;
        top: 0;

        &.rotate {
          transform: rotate(45deg);
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/new/style.js